export type OrderConfirmationChoice = "ACCEPTED" | "REJECTED" | "CHANGE_REQUESTED";
export type OrderConfirmationPlan = { date: string; quantity: number; note?: string; };
export type OrderConfirmationResponse = {
  id: string;
  responseType: OrderConfirmationChoice;
  reason: string | null;
  deliveryPlan: OrderConfirmationPlan[];
  createdAt: string;
};
export type OrderConfirmationWorkspace = {
  order: {
    id: string;
    orderNo: string;
    supplierName: string;
    requestTitle: string;
    offerNo: string;
    quantity: number;
    unit: string;
    totalAmount: number;
    currency: string;
    paymentDays: number;
    expectedDeliveryAt: string;
    deliveryAddress: string | null;
    confirmationStatus: string;
    version: number;
  };
  responses: OrderConfirmationResponse[];
};
export type OrderConfirmationInput = {
  responseType: OrderConfirmationChoice;
  reason?: string;
  deliveryPlan: OrderConfirmationPlan[];
  expectedVersion: number;
};
export function isCalendarDate(value: string) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const parsed = new Date(`${value}T00:00:00Z`);
  return Number.isFinite(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value;
}
export function validOrderConfirmation(input: OrderConfirmationInput, quantity: number, today: string) {
  if (input.responseType !== "ACCEPTED") return (input.reason?.trim().length ?? 0) >= 10;
  return input.deliveryPlan.length === 1 && input.deliveryPlan.every(plan =>
    isCalendarDate(plan.date) && plan.date >= today && Number.isFinite(plan.quantity) && plan.quantity > 0 && plan.quantity === quantity);
}
